module.exports = __webpack_public_path__ + "static/collectorcans-bg-6661cce733eecbf7e9d1e3bfd2f73d52.jpg";